module.exports = __webpack_public_path__ + "img/menuIcon4.3e6708a3.png";